<template>
  <div class="login-bgc">
       <img style="height: 510px;width: 400px;" src="~assets/img/login/login-bgc.jpeg" alt="">
  </div>
</template>

<script lang="js">
import {defineComponent, reactive, ref} from 'vue'

export default defineComponent({
  props: {

  },
  components: {

  },
  setup() {


    return {

    }

  }
})
</script>

<style scoped lang="less">
</style>




